import React from 'react';
import type { LayoutId } from './layouts';

export interface LayoutContextValue {
  layoutId: LayoutId;
}

export const LayoutContext = React.createContext<LayoutContextValue | undefined>(undefined);
